import { Loading, Text } from "@repo/skapa";
import { t } from "@repo/translation";

interface SearchResultHandlerProps {
  isValidating: boolean;
  isNoData: boolean;
  searchValue: string | undefined;
}

export const SearchResultHandler = ({
  isValidating,
  isNoData,
  searchValue,
}: SearchResultHandlerProps) => {
  if (isValidating) {
    return <Loading text={t("prompt.loading")} />;
  }

  if (isNoData && searchValue) {
    return (
      <Text>{t("prompt.no_result_for", { searchTerm: searchValue })}</Text>
    );
  }

  return null;
};
